export default __webpack_public_path__ + "static/media/deal-hend.98a4be62.svg";